import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const {guess,guesss,guessRecover,guessTitle,guessTitleBatch,
       guessGoods,guessGoodsBatch,guessRankingList,guessPlayer,
       guessPlayers,guessAnswerSubmit,guessAnswerStart,guessAnswerEnd,
       guessAnswerResult,guessReceived,guessFinish,guessSimple,guessExport,
       guessPlayerDel,guessPaid
} = api

/**
 * 查找列表
 */
export async function findGuesss(params) {
    return request({url: guesss, method: 'get', data: params,})
}
/**
 * 查找
 */
export async function findGuess(params) {
    return request({url: guess, method: 'get', data: params,})
}
/**
 * 创建竞猜
 */
export async function createGuesss(params) {
    return request({url: guesss, method: 'post', data: params,})
}
/**
 * 更新竞猜
 */
export async function updateGuess(params) {
    return request({url: guess, method: 'put', data: params,})
}
/**
 * 删除竞猜
 */
export async function deleteGuess(params) {
    return request({url: guess, method: 'delete', data: params,})
}
/**
 * 恢复竞猜
 */
export async function recoverGuess(params) {
    return request({url: guessRecover, method: 'put', data: params,})
}
/**
 * 查询题目
 */
export async function findGuessTitle(params) {
    return request({url: guessTitle, method: 'get', data: params,})
}
/**
 * 新增或更新题目
 */
export async function updateGuessTitleBatch(params) {
    return request({url: guessTitleBatch, method: 'patch', data: params,})
}
/**
 * 查询奖品
 */
export async function findGuessGoods(params) {
    return request({url: guessGoods, method: 'get', data: params,})
}
/**
 * 查询奖品
 */
export async function updateGuessGoodsBatch(params) {
    return request({url: guessGoodsBatch, method: 'patch', data: params,})
}

/**
 * 查询排行
 */
export async function findGuessRankingList(params) {
    return request({url: guessRankingList, method: 'get', data: params,})
}
/**
 * 查询
 */
export async function findGuessPlayer(params) {
    return request({url: guessPlayer, method: 'get', data: params,})
}
/**
 * 查询
 */
export async function createGuessPlayers(params) {
    return request({url: guessPlayers, method: 'post', data: params,})
}

/**
 * 答案提交
 */
export async function createGuessAnswerSubmit(params) {
    return request({url: guessAnswerSubmit, method: 'post', data: params,})
}
/**
 * 答案提交时间
 */
export async function findGuessTimeStart(params) {
    return request({url: guessAnswerStart, method: 'get', data: params,})
}
export async function findGuessTimeEnd(params) {
    return request({url: guessAnswerEnd, method: 'get', data: params,})
}
export async function findGuessAnswerResult(params) {
    return request({url: guessAnswerResult, method: 'get', data: params,})
}
export async function findGuessReceived(params) {
    return request({url: guessReceived, method: 'get', data: params,})
}
export async function findGuessFinish(params) {
    return request({url: guessFinish, method: 'get', data: params,})
}
export async function updateGuessSimple(params) {
    return request({url: guessSimple, method: 'put', data: params,})
}
export async function expGuessPlayer(params) {
    return request({url: guessExport, method: 'get', data: params,})
}
export async function deleteGuessPlayer(params) {
    return request({url: guessPlayerDel, method: 'post', data: params,})
}
export async function payGuessPaid(params) {
    return request({url: guessPaid, method: 'put', data: params,})
}






// WEBPACK FOOTER //
// ./src/services/guess.js